/**
 * ADMIN-T007 — build-time config baseline.
 *
 * The `__BUILD_CONFIG__` define is injected by `vite.config.ts` from `build/config.<mode>.json`.
 * Runtime overrides are applied later in `runtimeConfig.ts`.
 */

declare const __BUILD_CONFIG__: BuildConfig;
declare const __APP_MODE__: string;
declare const __APP_VERSION__: string;

export interface BuildConfig {
  api?: {
    coreBaseUrl?: string;
    biBaseUrl?: string;
  };
  features?: Record<string, boolean>;
  polling?: Record<string, number>;
  branding?: Record<string, string>;
}

export const BUILD_CONFIG: BuildConfig =
  typeof __BUILD_CONFIG__ === 'undefined' ? {} : __BUILD_CONFIG__;

export const APP_MODE: string = typeof __APP_MODE__ === 'undefined' ? 'unknown' : __APP_MODE__;
export const APP_VERSION: string =
  typeof __APP_VERSION__ === 'undefined' ? '0.0.0' : __APP_VERSION__;
